/**
 * https:www.notion.so/faire/FOI-Free-Shipping-aka-maximalist-XP-7a265a98b2634cafaa9b88dff6607094
 */
export const MAXIMALIST_FIRST_ORDER_INCENTIVE_240723 = 'MAXIMALIST_FIRST_ORDER_INCENTIVE_240723';
